export {
  DEFAULT_GA4_MEASUREMENT_ID,
  normalizeGa4MeasurementId,
} from "../../../shared/googleAnalytics";

/** Emitido depois que a rota pública atualiza o título e os metadados do documento. */
export const SEO_PAGEVIEW_READY_EVENT = "equipapro:seo-pageview-ready";

/** Páginas administrativas não devem distorcer a medição do site público. */
export function isPublicTrackablePath(path: string): boolean {
  return !path.startsWith("/admin") && !path.startsWith("/convite") && !path.startsWith("/redefinir-senha");
}

/** Mantém o contrato do evento de pageview independente do componente React. */
export function createGa4Pageview(location: string, title: string, url: string) {
  return {
    page_location: url,
    page_path: location,
    page_title: title,
  };
}
